import type { jobs as en } from "../en/jobs";
import type { Messages } from "../types";

export const jobs: Messages<typeof en> = {
  title: "المهام",
  description: "كل العمليات الطويلة في مكان واحد: إعادة التحميل والمزامنة والإجراءات الجماعية والنشر والتصدير، مع تقدّم مباشر وإيقاف مؤقت وإلغاء وإعادة محاولة.",
  tabs: { active: "قيد التنفيذ", finished: "المنتهية", failed: "تحتاج انتباهك", all: "الكل" },
  categories: { all: "كل الأنواع", sync: "مزامنة", bulk: "إجراءات جماعية", ai: "ذكاء اصطناعي", publish: "نشر", export: "تصدير", other: "أخرى" },
  status: { queued: "في الانتظار", running: "قيد التنفيذ", paused: "متوقفة مؤقتاً", succeeded: "اكتملت", failed: "فشلت", cancelled: "أُلغيت" },
  kinds: {
    resync_post: "إعادة تحميل التعليقات",
    resync_account: "مزامنة الحساب",
    backfill_sync: "استيراد المنشورات الأقدم",
    backfill_account: "الاستيراد الأولي",
    reconcile: "فحص دوري",
    bulk_comment_action: "إجراء جماعي على التعليقات",
    bulk_flag: "وسم العناصر",
    bulk_archive: "أرشفة التعليقات",
    publish: "نشر منشور",
    cross_post: "نشر على عدة حسابات",
    contact_export: "تصدير بيانات شخص",
    contact_delete: "حذف بيانات شخص",
    enrich_contact: "جلب ملف المعلّق",
    reembed: "إعادة بناء فهرس البحث",
    reclassify: "إعادة التصنيف بالذكاء الاصطناعي",
    report: "تقرير",
    semantic_reindex: "إعادة فهرسة المعرفة",
    calendar_refresh: "تحديث التقويم",
    automation_run_retry: "إعادة تشغيل الأتمتة",
    account_sync: "مزامنة الحساب",
    comment_reply: "رد على تعليق",
    comment_private_reply: "رد خاص",
    comment_delete: "حذف تعليق",
    comment_hide: "إخفاء تعليق",
    comment_unhide: "إظهار تعليق",
    message_send: "إرسال رسالة",
    bulk_undo: "التراجع عن إجراء جماعي",
    usage_reconcile: "إعادة احتساب استخدام الخطة",
    ai_key_provision: "إعداد مفتاح الذكاء الاصطناعي",
    ai_image: "صورة بالذكاء الاصطناعي",
    ai_image_edit: "تعديل صورة بالذكاء الاصطناعي",
    ai_caption: "تعليق بالذكاء الاصطناعي",
    ai_score: "تقييم المنشور",
    ai_rule: "قاعدة من وصف",
    ai_tts: "تحويل النص إلى كلام",
    ai_stt: "تحويل الكلام إلى نص",
    ai_occasion: "منشور ليوم من التقويم",
    agent_reply: "رد وكيل ذكي",
    agent_batch: "مسودات وكيل ذكي",
    media_refresh: "تحديث الوسائط",
    media_repair: "إعادة تحميل الصور",
    post_reload: "إعادة التحميل من إنستغرام",
    people_flag: "وسم أشخاص",
    people_mark: "تصنيف أشخاص",
    people_block: "حظر في منصة ملفك",
    people_unblock: "إلغاء حظر أشخاص",
    people_hide_comments: "إخفاء كل تعليقاتهم",
    people_unhide_comments: "إظهار تعليقاتهم",
    people_archive_comments: "أرشفة تعليقاتهم",
    people_unarchive_comments: "إلغاء أرشفة تعليقاتهم",
    people_delete_comments: "حذف كل تعليقاتهم",
    people_export: "تصدير الأشخاص",
  },
  counts: { done_zero: "{{count}} مكتملة", done_one: "{{count}} مكتملة", done_two: "{{count}} مكتملة", done_few: "{{count}} مكتملة", done_many: "{{count}} مكتملة", done_other: "{{count}} مكتملة", failed_zero: "{{count}} فاشلة", failed_one: "{{count}} فاشلة", failed_two: "{{count}} فاشلة", failed_few: "{{count}} فاشلة", failed_many: "{{count}} فاشلة", failed_other: "{{count}} فاشلة", skipped_zero: "{{count}} متخطاة", skipped_one: "{{count}} متخطاة", skipped_two: "{{count}} متخطاة", skipped_few: "{{count}} متخطاة", skipped_many: "{{count}} متخطاة", skipped_other: "{{count}} متخطاة", of: "{{done}} من {{total}}", items_zero: "{{count}} عنصر", items_one: "عنصر واحد", items_two: "عنصران", items_few: "{{count}} عناصر", items_many: "{{count}} عنصرًا", items_other: "{{count}} عنصر" },
  eta: { soon: "أقل من دقيقة متبقية", minutes_zero: "يتبقى نحو {{count}} دقيقة", minutes_one: "يتبقى نحو دقيقة واحدة", minutes_two: "يتبقى نحو دقيقتين", minutes_few: "يتبقى نحو {{count}} دقائق", minutes_many: "يتبقى نحو {{count}} دقيقة", minutes_other: "يتبقى نحو {{count}} دقيقة", hours_zero: "يتبقى نحو {{count}} ساعة", hours_one: "يتبقى نحو ساعة واحدة", hours_two: "يتبقى نحو ساعتين", hours_few: "يتبقى نحو {{count}} ساعات", hours_many: "يتبقى نحو {{count}} ساعة", hours_other: "يتبقى نحو {{count}} ساعة", estimating: "جارٍ تقدير الوقت…", waiting: "بانتظار البدء…", paused: "متوقفة مؤقتاً، تابعها متى شئت" },
  actions: {
    cancel: "إلغاء",
    pause: "إيقاف مؤقت",
    resume: "متابعة",
    retry: "إعادة المحاولة",
    retryFailed: "إعادة محاولة العناصر الفاشلة",
    report: "تقرير الأخطاء (CSV)",
    view: "عرض",
    viewAll: "عرض كل المهام",
    details: "التفاصيل",
    open: "فتح {{target}}",
  },
  confirmCancel: { title: "إلغاء هذه المهمة؟", body: "العناصر التي اكتملت تبقى كما هي، ويمكنك إعادة محاولة الباقي لاحقاً.", confirm: "إلغاء المهمة", keep: "متابعة التنفيذ" },
  empty: {
    active: { title: "لا شيء قيد التنفيذ", hint: "عمليات إعادة التحميل والمزامنة والإجراءات الجماعية تظهر هنا مع تقدّمها المباشر." },
    finished: { title: "لا مهام منتهية بعد", hint: "نحتفظ هنا بالمهام المكتملة ونتائجها." },
    failed: { title: "كل شيء على ما يرام", hint: "لا توجد مهمة فشلت أو تركت عناصر خلفها." },
    all: { title: "لا مهام بعد", hint: "ابدأ إعادة تحميل التعليقات على منشور أو إجراءً جماعياً من صندوق الوارد." },
  },
  drawer: {
    items: "العناصر",
    failedFirst: "الفاشلة أولاً",
    noItems: "لا توجد نتائج لكل عنصر في هذه المهمة.",
    failedGeneric: "فشلت هذه المهمة. أعد المحاولة لتشغيلها من جديد.",
    noItemsFailed: "فشلت هذه المهمة قبل أن تسجّل نتائج العناصر. أعد المحاولة لتشغيلها من جديد.",
    itemFailedGeneric: "فشل (لم يُسجَّل سبب)",
    error: "ما الخطأ الذي حدث",
    result: "النتيجة",
    created: "أُنشئت",
    started: "بدأت",
    finished: "انتهت",
    retryOf: "إعادة محاولة لمهمة سابقة",
    item: "العنصر {{n}}",
    attempts_zero: "{{count}} محاولة",
    attempts_one: "محاولة واحدة",
    attempts_two: "محاولتان",
    attempts_few: "{{count}} محاولات",
    attempts_many: "{{count}} محاولة",
    attempts_other: "{{count}} محاولة",
    filterAll: "الكل",
    filterFailed: "الفاشلة",
    filterOk: "المكتملة",
    filterSkipped: "المتخطاة",
  },
  tray: {
    label: "المهام",
    labelActive_zero: "المهام: {{count}} قيد التنفيذ",
    labelActive_one: "المهام: {{count}} قيد التنفيذ",
    labelActive_two: "المهام: {{count}} قيد التنفيذ",
    labelActive_few: "المهام: {{count}} قيد التنفيذ",
    labelActive_many: "المهام: {{count}} قيد التنفيذ",
    labelActive_other: "المهام: {{count}} قيد التنفيذ",
    title: "المهام",
    active: "قيد التنفيذ الآن",
    recent: "انتهت مؤخراً",
    empty: "لا مهام قيد التنفيذ",
    emptyHint: "تظهر العمليات الطويلة هنا مع تقدّمها المباشر.",
  },
  toast: {
    started: "بدأت: {{title}}",
    startedHint: "تابعها من قائمة المهام.",
    succeeded: "اكتملت: {{title}}",
    failed: "فشلت: {{title}}",
    cancelled: "أُلغيت: {{title}}",
    partial_zero: "فشل {{count}} عنصر",
    partial_one: "فشل عنصر واحد",
    partial_two: "فشل عنصران",
    partial_few: "فشل {{count}} عناصر",
    partial_many: "فشل {{count}} عنصرًا",
    partial_other: "فشل {{count}} عنصر",
  },
  ai: {
    ready: {
      image: "صورتك جاهزة",
      edit: "صورتك المعدّلة جاهزة",
      text: "نتيجة الذكاء الاصطناعي جاهزة",
    },
    failedTitle: "فشل: {{title}}",
    view: "عرض",
    retry: "إعادة المحاولة",
    useInPost: "استخدام في منشور",
    result: "النتيجة",
    noResult: "لم تُحفظ نتيجة لهذه المهمة.",
    score: "التقييم: {{score}}",
    prompt: "الوصف",
  },
  target: { publication: "المنشور", post: "المنشور", account: "الحساب", contact: "الشخص", comments: "التعليقات", comment: "التعليق", conversation: "المحادثة", org: "المؤسسة" },
  progressLabel: "تقدّم {{title}}",
  conflict: "لا يمكن تنفيذ ذلك على هذه المهمة الآن.",
  data: {
    retention: {
      title: "مدة الاحتفاظ بالبيانات",
      hint: "كم يحتفظ ملفك بالتعليقات والرسائل وسجلّها. نحتفظ أيضاً بما حُذف على إنستغرام، فلا يضيع شيء بالخطأ.",
      forever: "الاحتفاظ دائماً",
      foreverHint: "الخيار الموصى به. لا يُحذف شيء تلقائياً.",
      days: "الحذف بعد مدة",
      daysHint: "تُحذف كل ليلة التعليقات والرسائل الأقدم من المدة المحددة.",
      period: "الاحتفاظ لمدة",
      periodDays_zero: "{{count}} يوم",
      periodDays_one: "يوم واحد",
      periodDays_two: "يومان",
      periodDays_few: "{{count}} أيام",
      periodDays_many: "{{count}} يومًا",
      periodDays_other: "{{count}} يوم",
      save: "حفظ مدة الاحتفاظ",
      saved: "تم تحديث مدة الاحتفاظ",
      confirmTitle_zero: "حذف البيانات الأقدم من {{count}} يوم؟",
      confirmTitle_one: "حذف البيانات الأقدم من يوم واحد؟",
      confirmTitle_two: "حذف البيانات الأقدم من يومين؟",
      confirmTitle_few: "حذف البيانات الأقدم من {{count}} أيام؟",
      confirmTitle_many: "حذف البيانات الأقدم من {{count}} يومًا؟",
      confirmTitle_other: "حذف البيانات الأقدم من {{count}} يوم؟",
      confirmBody_zero: "كل ليلة ستُحذف نهائيًا التعليقات والرسائل ونسخها الأقدم من {{count}} يوم. لا يمكن التراجع عن ذلك.",
      confirmBody_one: "كل ليلة ستُحذف نهائيًا التعليقات والرسائل ونسخها الأقدم من يوم واحد. لا يمكن التراجع عن ذلك.",
      confirmBody_two: "كل ليلة ستُحذف نهائيًا التعليقات والرسائل ونسخها الأقدم من يومين. لا يمكن التراجع عن ذلك.",
      confirmBody_few: "كل ليلة ستُحذف نهائيًا التعليقات والرسائل ونسخها الأقدم من {{count}} أيام. لا يمكن التراجع عن ذلك.",
      confirmBody_many: "كل ليلة ستُحذف نهائيًا التعليقات والرسائل ونسخها الأقدم من {{count}} يومًا. لا يمكن التراجع عن ذلك.",
      confirmBody_other: "كل ليلة ستُحذف نهائيًا التعليقات والرسائل ونسخها الأقدم من {{count}} يوم. لا يمكن التراجع عن ذلك.",
      confirm: "تفعيل الحذف",
      readOnly: "يمكن للمالك والمسؤولين فقط تغيير مدة الاحتفاظ.",
      current: "السياسة الحالية",
      updated: "حُدّثت {{when}}",
    },
    incidents: {
      title: "الحوادث",
      hint: "تفحص منصة ملفك كل حساب متصل كل بضع دقائق. إذا وجدت تعليقات أو رسائل فاتت التحديثات المباشرة، تسجّل حادثة.",
      open: "مفتوحة",
      resolved: "محلولة",
      all: "الكل",
      empty: "لا توجد حوادث",
      emptyHint: "التحديثات المباشرة تصل بشكل طبيعي.",
      resolve: "تحديد كمحلولة",
      resolvedToast: "تم حل الحادثة",
      recovered_zero: "استُعيد {{count}} عنصر",
      recovered_one: "استُعيد عنصر واحد",
      recovered_two: "استُعيد عنصران",
      recovered_few: "استُعيد {{count}} عناصر",
      recovered_many: "استُعيد {{count}} عنصرًا",
      recovered_other: "استُعيد {{count}} عنصر",
      silent_zero: "لا تحديثات مباشرة منذ {{count}} دقيقة",
      silent_one: "لا تحديثات مباشرة منذ دقيقة واحدة",
      silent_two: "لا تحديثات مباشرة منذ دقيقتين",
      silent_few: "لا تحديثات مباشرة منذ {{count}} دقائق",
      silent_many: "لا تحديثات مباشرة منذ {{count}} دقيقة",
      silent_other: "لا تحديثات مباشرة منذ {{count}} دقيقة",
      occurrences_zero: "تكرر {{count}} مرة",
      occurrences_one: "تكرر مرة واحدة",
      occurrences_two: "تكرر مرتين",
      occurrences_few: "تكرر {{count}} مرات",
      occurrences_many: "تكرر {{count}} مرة",
      occurrences_other: "تكرر {{count}} مرة",
      opened: "فُتحت {{when}}",
      lastSeen: "آخر ظهور {{when}}",
      resolvedAt: "حُلّت {{when}}",
      adminOnly: "الحوادث مرئية للمالك والمسؤولين.",
      explain: "قد تكون التحديثات المباشرة متوقفة: العناصر المستعادة تمرّ على قواعدك أيضًا، فلا يفوتك شيء.",
    },
  },
  sync: {
    health: "حالة المزامنة",
    lastWebhook: "آخر تحديث مباشر",
    lastReconcile: "آخر فحص",
    cadence: "الفحص",
    cadenceActive: "كل 10 دقائق",
    cadenceQuiet: "كل ساعة",
    recovered: "المستعادة",
    never: "أبداً",
    resync: "زامِن الآن",
    resyncHint: "يعيد قراءة كل منشور وتعليق ورسالة (بحد أقصى وقابل للاستكمال). العناصر الناقصة تمرّ على قواعدك.",
    incidentTitle: "قد تكون التحديثات المباشرة متوقفة لـ ‎@{{user}}",
    incidentBody_zero: "لم يصل أي تحديث مباشر منذ {{minutes}} د بينما وجد الفحص الدوري {{count}} عنصر. تواصل منصة ملفك استعادتها تلقائيًا.",
    incidentBody_one: "لم يصل أي تحديث مباشر منذ {{minutes}} د بينما وجد الفحص الدوري عنصر واحد. تواصل منصة ملفك استعادتها تلقائيًا.",
    incidentBody_two: "لم يصل أي تحديث مباشر منذ {{minutes}} د بينما وجد الفحص الدوري عنصرين. تواصل منصة ملفك استعادتها تلقائيًا.",
    incidentBody_few: "لم يصل أي تحديث مباشر منذ {{minutes}} د بينما وجد الفحص الدوري {{count}} عناصر. تواصل منصة ملفك استعادتها تلقائيًا.",
    incidentBody_many: "لم يصل أي تحديث مباشر منذ {{minutes}} د بينما وجد الفحص الدوري {{count}} عنصرًا. تواصل منصة ملفك استعادتها تلقائيًا.",
    incidentBody_other: "لم يصل أي تحديث مباشر منذ {{minutes}} د بينما وجد الفحص الدوري {{count}} عنصر. تواصل منصة ملفك استعادتها تلقائيًا.",
  },
};
